import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Close, CheckCircle, Warning, Error, Info } from '@mui/icons-material';
import { useNotification } from './NotificationContext';
import { NotificationData } from './types';
import { notificationSystemStyles } from './NotificationSystem.styles';

const NotificationItem: React.FC<{ notification: NotificationData }> = ({ notification }) => {
  const { removeNotification } = useNotification();

  const getIcon = () => {
    switch (notification.type) {
      case 'success':
        return <CheckCircle sx={notificationSystemStyles.icon} />;
      case 'warning':
        return <Warning sx={notificationSystemStyles.icon} />;
      case 'error':
        return <Error sx={notificationSystemStyles.icon} />;
      case 'info':
        return <Info sx={notificationSystemStyles.icon} />;
      default:
        return <Info sx={notificationSystemStyles.icon} />;
    }
  };

  const getNotificationStyles = () => {
    switch (notification.type) {
      case 'success':
        return { ...notificationSystemStyles.notification, ...notificationSystemStyles.notificationSuccess };
      case 'warning':
        return { ...notificationSystemStyles.notification, ...notificationSystemStyles.notificationWarning };
      case 'error':
        return { ...notificationSystemStyles.notification, ...notificationSystemStyles.notificationError };
      case 'info':
        return { ...notificationSystemStyles.notification, ...notificationSystemStyles.notificationInfo };
      default:
        return { ...notificationSystemStyles.notification, ...notificationSystemStyles.notificationInfo };
    }
  };

  return (
    <Box sx={getNotificationStyles()}>
      {getIcon()}
      <Box sx={notificationSystemStyles.content}>
        {notification.title && (
          <Typography sx={notificationSystemStyles.title}>
            {notification.title}
          </Typography>
        )}
        <Typography sx={notificationSystemStyles.message}>
          {notification.message}
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={() => removeNotification(notification.id)}
        sx={notificationSystemStyles.closeButton}
      >
        <Close fontSize="small" />
      </IconButton>
    </Box>
  );
};

const NotificationSystem: React.FC = () => {
  const { notifications } = useNotification();

  if (notifications.length === 0) {
    return null;
  }

  const containerStyle = notificationSystemStyles.containerError;

  return (
    <Box sx={containerStyle}>
      {notifications.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </Box>
  );
};

export default NotificationSystem;